import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { LoadingTemplateList } from './LoadingTemplateList.tsx';

export const TemplateListLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplateList" */ './TemplateList.tsx'))
			.TemplateList,
	loading: () => <LoadingTemplateList />,
});
